import {
  ITableTitle,
} from "apps/website/components/feature/Table/ColumnRowTable/ColumnRowTable";
import { BRANDS } from "apps/website/constants/brands";

export const brandTitles: ITableTitle[] = [
  { id: "KATKIN",
    name: BRANDS.KATKIN,
    subheading: "Cluck Recipe",
  },
  { id: "LILYS_KITCHEN",
    name: BRANDS.LILYS_KITCHEN,
    subheading: "Smooth Chicken Pate",
  },
  { id: "GORMET",
    name: "Gourmet",
    subheading: "Mon Petit Intense With Chicken",
  },
  { id: "SHEBA",
    name: BRANDS.SHEBA,
    subheading: "Fresh & Fine Cat Pouches with Chicken in Jelly" },
  { id: "WHISKAS",
    name: BRANDS.WHISKAS,
    subheading: "Poultry Feasts in Jelly with Chicken",
  },
  { id: "FELIX",
    name: "Felix",
    subheading: "As Good As It Looks with Chicken in Jelly",
  },
];

export const brandComparisonTableData = {
  titles: brandTitles,
  rows: [
    {
      title: "100% gently-cooked meat*",
      values: [ true, false, false, false, false, false ],
    },
    {
      title: "So fresh it's frozen",
      values: [ true, false, false, false, false, false ],
    },
    {
      title: "Cooked in own kitchen",
      values: [ true, false, true, true, true, true ],
    },
    {
      title: "Tailored portions for your cat",
      values: [ true, false, false, false, false, false ],
    },
    {
      title: "From less than £2 a day",
      values: [ true, false, true, true, true, true ],
    },
  ],
  footer: "<p>Data accurate as of June 2025. Brand names used for comparison only. </p><p>Daily price calculations based on brand recommended feeding guidelines</p><p><sup>*</sup>All KatKin recipes are gently cooked at <100 degrees<p>",
};
